import { Component, ViewChild } from '@angular/core';
import { RoleService } from 'src/app/services/role.service';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators,FormControl } from '@angular/forms'
import { CustomValidatorsService } from 'src/app/services/custom-validators.service';
import { ToastMsg, ToastmsgService } from 'src/app/util/toastmsg/toastmsg.service';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { UserPrivilegeService } from 'src/app/services/user-privilege.service';
import { Location } from '@angular/common';

export interface PeriodicElement {
  description: string;
  roleName:string;
  sr: string;
  privs: string;
  
 
}

const ELEMENT_DATA: PeriodicElement[] = [
  {sr: '', roleName:'', description: '', privs: ''},
  


];
@Component({
  selector: 'app-travel-desk',
  templateUrl: './travel-desk.component.html',
  styleUrls: ['./travel-desk.component.css']
})
export class TravelDeskComponent {
  @ViewChild(MatPaginator) paginator!: MatPaginator;

  islisthide:boolean=true;
  displayedColumns: string[] = ['sr','roleName', 'description', 'privileges'];
  dataSource:any = [];
  totalElements: number = 0;
  
  menuListData:any;
  menuList:any;
  menuPrivileges:any;
  selectedMenu:any;
  selectedMenuPrivileges:any;

  moduleListData:any;
  moduleList:any;
  selectedModule:any;
  selectedModulePrivileges:any;
  moduleLists:any
  modulePrivileges:any=[]


  permissionsLists:any
  roleFg:any=[];
  searchText:any;
  roleModify:any=[];
  action:string;
  privilegesView:any
  privilegesAdd:any
  privilegesEdit:any
constructor(private userPrivileges:UserPrivilegeService,private RoleService : RoleService,
  private fb : FormBuilder,private location:Location,
  private toastMsgService : ToastmsgService,
  private customValidator : CustomValidatorsService,
  ){

    this.userPrivileges.userPrivilegesByModule('Roles-Permission').then((privileges:any) => {
      this.privilegesValue(privileges)
    })
    .catch((error:any) => {
    console.error(error); // Handle errors, if any
    });


    this.action="New";
    this.getAllRoles({ strpage: "0", size: "10"},{searchText:"",roleId:"0"});
    
    // this.userPrivileges.userPrivilegesByModule('roles').then((privileges:any) => {
    //   this.privilegesValue(privileges)
    // })
    // .catch((error:any) => {
    // console.error(error); // Handle errors, if any
    // });
    // this.privilegesValue("view")
}
ngOnInit(): void {
  this.getAllPrivileges();
  this.searchText=""
}
onsearchText(){
  this.getAllRoles({ strpage: "0", size: "10"},{searchText:this.searchText,roleId:0});

}
privilegesValue(privs:any){
  
  let privileges="";
  if(privs.includes('add')){
    this.privilegesAdd="VAMD"
  }
  if(privs.includes('modify')){
    this.privilegesEdit="VAMD"
  }
if(privs.includes('view')){
  this.privilegesView="VAMD"
}else{
  this.privilegesView="AccessDenied"
}

}
  onAddNew(){
    this.roleFg=this.fb.group({
      "roleName" :  ['',[Validators.required]],
      "description" : ['',],
      "menu":[''],
      "menuPrivileges":['',[Validators.required]],
      "module":[''],
      "modulePrivileges":['',[Validators.required]],
      "privileges":[''],
    });
    this.action="New";
   this.roleModify.roleName=""
   this.roleModify.description=""
   this.selectedModule=[];
   this.selectedModulePrivileges=[];
    this.islisthide=false;
    
  }
  onBackbuttonClick(){
    this.islisthide=true;
  }
  backClick(){
this.location.back()
  }
 
  onMenuChange(){
    let selectedMenuPrivilegesData:any = []
    for (let i = 0; i < this.selectedMenu.length; i++) {
      
     if(this.selectedMenu[i]!=="all"){
     
     let selectedMenuData= this.menuListData.filter((itm:any)=>itm.includes(this.selectedMenu[i]))
     
 
   for(let j=0;j<selectedMenuData.length;j++){
     selectedMenuPrivilegesData.push(selectedMenuData[j])
   }
    }
    else{
     this.moduleList=this.permissionsLists
    }
     }
    
     this.menuPrivileges = selectedMenuPrivilegesData
   }

  onModuleChange(){
   
   let selectedModulePrivilegesData:any = []
  
   for (let i = 0; i < this.selectedModule.length; i++) {
    if(this.selectedModule[i]!=="all"){
    
    let selectedModelData= this.moduleListData.filter((itm:{ name: any; })=>itm.name === this.selectedModule[i])
   

    const obj= selectedModelData.reduce((acc: string[], curr: { permissions: any[]; name: any; }) => {
      curr.permissions.forEach(perm => {
        acc.push(`${curr.name}=>${perm}`);
      });
     
      return acc;
    }, []);
   
   selectedModulePrivilegesData = selectedModulePrivilegesData.concat(obj)
    //this.permissionsList=obj
   
   }
   else{
    this.moduleList=this.permissionsLists
   }
    }
    
    this.modulePrivileges = selectedModulePrivilegesData
  }



  saveRole() {
      
     let menuPrivileges:any = [];
      for(let i=0;i<this.selectedMenuPrivileges.length;i++){
        const menuItm = "menu=>"+this.selectedMenuPrivileges[i];
        menuPrivileges.push(menuItm);
      }
      
      let modulePrivileges:any = this.selectedModulePrivileges
      

      const userPrivileges = menuPrivileges.concat(modulePrivileges);
      
    this.roleFg.value.privileges = userPrivileges;
   this.RoleService.saveTravellerRole(this.roleFg.value)
      .subscribe({
        next : (res) => {
          if(res.status==200 || res.status==201) {
            if(this.action==="New"){
            this.toastMsgService.setMsg({msg : "Role Added Successfully!",msgTitle : "Success", msgType : "I"});}
           // this.router.navigate(["/sign-in"]);
           if(this.action==="Update"){
            this.toastMsgService.setMsg({msg : "Role Updated Successfully!",msgTitle : "Success", msgType : "I"});}
           
           this.getAllRoles({ strpage: "0", size: "10"},{searchText:"",roleId:"0"});

           this.islisthide=true;
          } else {
            const body : any = res.body;
            this.registerUserErrorMsg(res.status,body?.result);
          } 
        },error : (err) => {

          this.registerUserErrorMsg(err.status,err.error);
        }
      }
    )
  }

  registerUserErrorMsg(status : number,msg : string) {
    if(this.action==="New"){
    if(status >=500) {
      this.toastMsgService.setMsg({msg : "Failed to Save",msgTitle : "Warning", msgType : "W"});
    } else {

      this.toastMsgService.setMsg({msg : "Failed to Save",msgTitle : "Warning", msgType : "W"});
    } 
  }
    if(this.action==="Update"){
      if(status >=500) {
        this.toastMsgService.setMsg({msg : "Failed to Update",msgTitle : "Warning", msgType : "W"});
      } else {
  
        this.toastMsgService.setMsg({msg :  "Failed to Update",msgTitle : "Warning", msgType : "W"});
      } }
  }

  getMenuList(privilegeList:any){
    const permissions=privilegeList.menu;
    
    let menu:any = [];
    for(let i=0;i<permissions.length;i++){
      let mods= permissions[i].split('=>')
      let module = mods[0]
      if(!menu.includes(module)){
        menu.push(module)
      }
    }
    this.menuList = menu
  }

  getModuleList(privilegeList:any){
    

    for (let i = 0; i < privilegeList.length; i++) {
      if (privilegeList[i] === 'menu') {
        privilegeList.splice(i, 1); // Remove the item at index i
        break; // Stop the loop once the item is removed
      }
    }
    
    const permissions=privilegeList
    const convertToArray = Object.keys(permissions);
  
    this.moduleList=convertToArray
    
    this.moduleListData = Object.entries(permissions).map(([key, value]) => {
     return {
       name: key,
       permissions: value
     };
    
   });
   const output = this.moduleListData.reduce((acc: string[], curr: { permissions: any[]; name: any; }) => {
     curr.permissions.forEach(perm => {
       acc.push(`${curr.name}=>${perm}`);
     });
     return acc;
   }, []);
   this.permissionsLists=output

  }


  getAllPrivileges(){

   this.RoleService
    .getAllTravellerPrivileges()
    .subscribe({
      next : (res:any) => {
        if(res) {
          const data = res
         
         const permissionsListMenu=data
         
         
          this.menuListData = permissionsListMenu.menu
          this.getMenuList(permissionsListMenu)

          const permissionsListModule =  JSON.parse(JSON.stringify(data))

          const { menu, ...permissionListModuleFinal } = permissionsListModule;
         
            this.moduleListData = permissionListModuleFinal
          this.getModuleList(permissionListModuleFinal)
   
        } else {
        
        } 
      },error : (err) => {

        console.error("Error in fetching all getAllRoles");
      }
    }
  )
  }
  nextPage(event:PageEvent) {
    let page:any = {};
    page['strpage'] = event.pageIndex.toString();
    page['size'] = event.pageSize.toString();
    let searchField:any={};
    searchField['searchText'] = this.searchText;
    searchField['roleId'] = 0;
    this.getAllRoles(page,searchField)
  
  }
  getAllRoles(page:any,searchField:any){
    this.RoleService
    .getAllTravellerRoles(page,searchField)
    .subscribe({
      next : (res:any) => {
        if(res) {
          const data = res.result
         
         // this.Userlist=data.result.content;
         this.totalElements = data['totalElements'];

          this.dataSource=data.content;
     
        } else {
        
        } 
      },error : (err) => {

        console.error("Error in fetching all getAllUsers");
      }
    }
  )
  }
  getRoleById(id:any){
    this.roleFg=this.fb.group({
      "roleName" :  ['',[Validators.required]],
      "description" : ['',],
      "menu":[''],
      "menuPrivileges":['',[Validators.required]],
      "module":[''],
      "modulePrivileges":['',[Validators.required]],
      "privileges":[''],
      "roleId":[id.roleId]
    })
   
    this.action="Update";
    this.getAllPrivileges();
    this.islisthide=false;
    this.RoleService
    .getRoleTravellerbyId(id.roleId)
    .subscribe({
      next : (res:any) => {
        if(res) {
          const data = res
         this.roleModify=data.result
         // this.Userlist=data.result.content;
        
         this.mapMenuModulePrivileges(data.result.privileges)
        
     
        } else {
        
        } 
      },error : (err) => {

        console.error("Error in fetching getRoleById");
      }
    }
  )
  }
  mapMenuModulePrivileges(privileges:any){
   
    let modules:any = [];
  const modulePrivileges = privileges.filter((itm:any)=>!itm.includes("menu"))
  
    for(let i=0;i<modulePrivileges.length;i++){
      let mods= modulePrivileges[i].split('=>')
      let module = mods[0]
      if(!modules.includes(module)){
      modules.push(module)
      }

    }
  
    this.selectedModule = modules
    this.onModuleChange()
   this.selectedModulePrivileges=modulePrivileges


   let menus:any = [];
   const menuPrivileges = privileges.filter((itm:any)=>itm.includes("menu"))
   let menuPrivilegesFinal = []
   
   for(let i=0;i<menuPrivileges.length;i++){
    const menuItem  = menuPrivileges[i].replace("menu=>","");
    menuPrivilegesFinal.push(menuItem)
    
    let menu=menuItem;
    if(menuItem.includes("=>")){
     let mens = menuItem.split('=>')
      menu = mens[0]  
      
    }
     if(!menus.includes(menu)){
      menus.push(menu)
     }

   }
   
   this.selectedMenu = menus
   this.onMenuChange()
  this.selectedMenuPrivileges=menuPrivilegesFinal
  }

  openPopup() {
    this.islisthide=false;
  }
  closePopup() {
    this.islisthide=true;
  
  }

}
